// Form submission composable
export function useFormSubmission() {
  const submitForm = async (formData) => {
    try {
      // Check if we're in development or if Netlify functions are available
      const isDevelopment = import.meta.env.DEV
      const hasNetlifyFunctions = !isDevelopment
      
      if (isDevelopment || !hasNetlifyFunctions) {
        // Development mode or no Netlify functions available
        console.log('Development mode: Simulating form submission')
        console.log('Form data:', formData)
        
        // Simulate API call for development
        await new Promise(resolve => setTimeout(resolve, 1500)) // Simulate network delay
        
        // Simulate successful response
        return {
          success: true,
          message: 'Thanks for joining our waitlist! We\'ll be in touch soon.',
          data: {
            id: 'dev-' + Date.now(),
            email: formData.email,
            state: formData.state,
            agency_name: formData.agency_name,
            created_at: new Date().toISOString()
          }
        }
      } else {
        // Production: Use Netlify function
        const response = await fetch('/.netlify/functions/submit-waitlist', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData)
        })

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }

        const result = await response.json()

        if (!result.success) {
          throw new Error(result.error || 'Submission failed')
        }

        return result
      }
    } catch (error) {
      console.error('Form submission error:', error)
      throw error
    }
  }

  return {
    submitForm
  }
}
